const blobToFile = async (blobUrl: string, fileName: string) => {
  const response = await fetch(blobUrl);
  const blob = await response.blob();
  return new File([blob], fileName, { type: blob.type });
};

export { blobToFile }